import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CrudService } from './../../../crud/crud.service';
import { Router } from '@angular/router';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-grupo-formulario',
  templateUrl: './formulario.component.html'
})

export class FormularioComponent implements OnInit{
  dato: FormGroup;

  cambiarAll = true;
  cargarDatosCatalogo = false;

  // Mensaje
  titulo; mensaje; clase;

  nuevo_periodo = {};
  periodo = {
    periodos_siguientes: ''
  };
  tamano = document.body.clientHeight;
  constructor(private route: ActivatedRoute, private router: Router, private fb: FormBuilder, private crud: CrudService) { }

  ngOnInit() {
    this.dato = this.fb.group({
      id: [''],
      periodos_escolares_id: ['', [Validators.required]],
      grupos: this.fb.array([])

    });

    //Solo si se va a cargar catalogos poner un <a id="catalogos" (click)="ctl.cargarCatalogo('modelo','ruta')">refresh</a>
    document.getElementById("catalogos").click();
  }

  cargar_grupo(url) {
    if (url != '') {
      this.cargarDatosCatalogo = true;
      this.dato.controls.grupos = this.fb.array([]);
      this.crud.ver(this.dato.controls.periodos_escolares_id.value, url).subscribe(
        resultado => {
          this.cargarDatosCatalogo = false;
          let avanzar = 0;
          this.nuevo_periodo = {};
          this.periodo = resultado.data;
          if (resultado.data.periodos_siguientes != null) {
            this.nuevo_periodo = resultado.data.periodos_siguientes; // periodo pasado de este periodo
            avanzar = 1;
          }
          if (resultado.data.grupos != null) {
            let no_hay = 0;
            resultado.data.grupos.forEach(element => {
              if (element.continuado == 0) {
                no_hay++;
                this.dato.controls.grupos['controls'].push(
                  this.fb.group({
                    'id': element.id,
                    'clave': element.clave,
                    'nombre': element.nombre,
                    'nivel': element.nivel,
                    'identificador': element.identificador,
                    'carrera': element.carreras_planes.carreras.nombre,
                    'nivel_siguiente': element.nivel + 1,
                    'nivel_tope': element.carreras_planes.carreras.numero_periodos,
                    'tipo_periodo': element.carreras_planes.carreras.tipos_periodos.nombre,
                    'avanzar': avanzar
                  })
                );
              }
            });
            if (no_hay == 0) {

              this.titulo = "Ningun grupo";
              this.mensaje = "No hay grupo siguiente para avanzar";
              this.clase = "warning";
              document.getElementById("message").click();
            }
          }
        },
        error => {
          this.cargarDatosCatalogo = false;
          this.titulo = "Sin resultados";
          this.mensaje = "No se encontro datos";
          this.clase = "warning";
          document.getElementById("message").click();
        }
      );
    }
  }

  checkAll() {
    this.dato.controls.grupos["controls"].forEach(element => {
      element.controls.avanzar.patchValue(this.cambiarAll);
    });
  }
}
